import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC9oBOSuxFWF4cJnD-3YHTkyFNx8t_VPq4",
  authDomain: "kryptonian-furniture-new.firebaseapp.com",
  projectId: "kryptonian-furniture-new",
  storageBucket: "kryptonian-furniture-new.firebasestorage.app",
  messagingSenderId: "15633829645",
  appId: "1:15633829645:web:17a1cb292d1b9d1a4c2a44",
  measurementId: "G-T56JQD6GG4"
};
// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

export default app;